import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';

import { Decimal } from 'decimal.js';
import { Observable } from 'rxjs';

import { ILinearBetslipMessages } from '../../../../../base/models/betslip-messages';
import {
    ILinearBetslipMessagesProviderService,
    LINEAR_BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN,
} from '../../../../../base/services/betslip-messages-provider.service';
import {
    IContainerSummary,
    ILinearContainerSummaryService,
    LINEAR_CONTAINER_SUMMARY_SERVICE,
} from '../../../services/linear/linear-container-summary.interface';

@Component({
    selector: 'bs-linear-container-possible-winnings',
    templateUrl: './linear-container-possible-winnings.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./linear-container-possible-winnings.component.scss'],
    standalone: false,
})
export default class LinearContainerPossibleWinningsComponent implements OnInit {
    summary$: Observable<IContainerSummary | null>;

    readonly messages: ILinearBetslipMessages;

    constructor(
        @Inject(LINEAR_BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN) messageProvider: ILinearBetslipMessagesProviderService,
        @Inject(LINEAR_CONTAINER_SUMMARY_SERVICE) private summaryService: ILinearContainerSummaryService,
    ) {
        this.messages = messageProvider.getMessages();
    }

    ngOnInit(): void {
        this.summary$ = this.summaryService.getSummary$();
    }

    getPossibleWinningsValue({ possibleWinnings, boostedWinnings, showEmptyPossibleWinnings }: IContainerSummary): Decimal | null {
        if (showEmptyPossibleWinnings && possibleWinnings === null) {
            return null;
        }

        // boostedWinnings is used for OddsBoost only, the unboosted winnings do not matter for OddsBoost
        // for AccaBoost possibleWinnings is used and originalWinnings is used to store the unboosted winnings
        return boostedWinnings ?? possibleWinnings ?? new Decimal(0);
    }
}
